import { AuthGuard } from '@agent-ds/shared/guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobStudentMatchingPageComponent, StudentJobMatchingPageComponent } from './pages';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: 'student-job/:id', component: StudentJobMatchingPageComponent },
      { path: 'job-student/:id', component: JobStudentMatchingPageComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MatchingRoutingModule {}
